import { useState, useEffect, useCallback, useContext } from "react";
import { useLocation } from "react-router-dom";
import Searchbar from "../components/Searchbar";
import ItemJourney from "../components/work-item/LifeCycleDetailed";
import ItemJourneyOverview from "../components/work-item/LifeCycleOverview";
import { ReactFlowProvider } from 'reactflow';
import { MyContext } from "../context/myContext";
import useApi from "../hooks/useApi";
import itemDetailsApiList from "../api/ItemDetailsApi";
import { Select } from "antd";

const getFilterStorageKey = (product) => `lifeCycleFilters_${product}`;

function ItemDetails() {
  const [itemId, setItemId] = useState(null);
  const [itemData, setItemData] = useState({});
  const [counter, setCounter] = useState(0); // for slider in work item journey component 
  const [searchVal, setSearchVal] = useState('');
  const [stateGroups, setStateGroups] = useState(null);
  const { workItemClicked, selectedProduct, setIsJourneyView, isJourneyView } = useContext(MyContext);
  const getWorkItemsStateApi = useApi(itemDetailsApiList.getWorkItemsState)
  const getItemLifeCycleApi = useApi(itemDetailsApiList.getItemLifeCycle)

  const getItemDetailsUrl = useApi(itemDetailsApiList.getWorkItemDetails)

  const location = useLocation(); // Hook to access the location object
  const FILTER_STORAGE_KEY = getFilterStorageKey(selectedProduct);
  const [filters, setFilters] = useState(() => {
    const storedFilters = localStorage.getItem(FILTER_STORAGE_KEY);
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
        isJourneyView: isJourneyView,
        selectedRelease: '',
        metric: '',
        searchWorkId: ''
      };
  });

  useEffect(() => {
    localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));  
  }, [filters, selectedProduct]);

  const updateFilter = useCallback((key, value) => {
    setFilters((prevFilters) => {
      if (prevFilters[key] !== value) {
        return { ...prevFilters, [key]: value };
      }
      return prevFilters;
    });

  }, []);

  const getFiltersFromStorage = async () => {
    if (workItemClicked) return;
    const storedFilters = JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY));
    storedFilters?.searchWorkId && setSearchVal(storedFilters?.searchWorkId)
  }



  useEffect(() => {
    const fetchStateGroups = async () => {
      try {
        const response = await getWorkItemsStateApi.request(selectedProduct);
  
        if (!response?.data?.stateData) {
          throw new Error("Invalid API response");
        }
  
        const { stateData } = response.data;
  
        // Group states by category and sort by category_id
        const groupedStates = stateData
          .sort((a, b) => a.category_id - b.category_id)
          .reduce((acc, { category, state }) => {
            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push(state);
            return acc;
          }, {});
  
        setStateGroups(groupedStates);
        getFiltersFromStorage();
      } catch (error) {
        console.error("Error fetching state groups:", error);
      }
    };

    fetchStateGroups();
  }, []);

  const updateItemData = (searchId, apiData) => {
    setItemId(searchId);
    setItemData(apiData);
    setCounter(0);
    updateFilter('searchWorkId', searchId)
  };

  const toggleView = useCallback((option) => {
    setIsJourneyView(option === "Details");
  }, []);



  const renderWorkItemComponents = () => {
    if (!itemId || !itemData) return null;
  
    return isJourneyView ? (
        <ItemJourney
          apiUrl={getItemDetailsUrl}
          itemId={itemId}
          apiData={itemData}
          counter={counter}
          setCounter={setCounter}
          stateGroups={stateGroups}
        />
    ) : (
      <ItemJourneyOverview
        apiUrl={getItemDetailsUrl}
        itemId={itemId}
        apiData={itemData}
        stateGroups={stateGroups}
      />
    );
  };
  
  


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const workItemId = queryParams.get("workItemId");
    if (workItemClicked) {
      if (workItemId) {
        setItemId(workItemId);
        setSearchVal(workItemId)
        updateFilter('workItemId', workItemId)
      }
    }
  }, [location.search]);


  useEffect(() => {
    if (stateGroups && !workItemClicked) {
      getFiltersFromStorage();
    }
  }, [workItemClicked]);
  return (
    <div>
      <div className="flex items-center justify-center gap-4 mt-2 mr-32">
      <div className="workitem-select-container">
      <Select
          value={isJourneyView ? "Detailed Journey" : "Overview"}
          className="w-[180px] workitem-view-select"
          onChange={(value) => {
            toggleView(value);
            updateFilter("isJourneyView", value === "Details");
          }}
          dropdownStyle={{ minWidth: "140px", maxHeight: "200px" }}
        >
          <Select.Option value="Overview" className="text-base px-3 py-2">
            Overview
          </Select.Option>
          <Select.Option value="Details" className="text-base px-3 py-2">
            Detailed Journey
          </Select.Option>
        </Select>
        </div>
        <span className="text-base">of Work Item</span>

        <Searchbar
          apiUrl={getItemLifeCycleApi}
          updateItemData={updateItemData}
          searchVal={searchVal}
          setSearchVal={setSearchVal}
        />
      </div>

      <div style={{ height: '88%' }}>
        <ReactFlowProvider>
        
          {renderWorkItemComponents()}
        </ReactFlowProvider>
      </div>
    </div>
  );
}

export default ItemDetails;
